import "./Orders.style.css"

// Components
import NavigationBar from "../../Components/NavigationBar";
import SideBar from "../../Components/SideBar";
import PaginationAdvanced from '../../Components/PaginationAdvanced';

// Function
import formatRupiah from "../../Function/formatRupiah";
import formatDateTime from "../../Function/formatDateTime";

// React Bootstrap
import { Button, InputGroup, Form, Badge, Modal, Spinner, Placeholder } from "react-bootstrap";

// React
import { useEffect, useState } from "react";

// React Bootstrap Icons
import { Search, PlusLg } from "react-bootstrap-icons";

// React Router Dom
import { useNavigate } from "react-router-dom";

// Axios
import axios from "axios";

// Sweet Alert 2
import Swal from "sweetalert2";

// Assets
import imageLogo from "../../logo.png";

const PageOrders = () => {
    const navigate = useNavigate();

    const [isPageLoading, setIsPageLoading] = useState(true);
    const [isLoading, setIsLoading] = useState(false);

    const [alertMessage, setAlertMessage] = useState({});

    const [accessToken] = useState(localStorage.getItem("accessToken"));
    // const [userData] = useState(JSON.parse(localStorage.getItem("userData")));

    const [orderData, setOrderData] = useState([]);
    const [orderDetails, setOrderDetails] = useState([]);
    const [orderSearch, setOrderSearch] = useState(new Date().toISOString().slice(0, 10));
    const [orderPage, setOrderPage] = useState(1);

    const [ordersShow, setOrdersShow] = useState({ status: false, id: null });
    const [receiptShow, setReceiptShow] = useState({ status: false, id: null });

    const [orderDescription, setOrderDescription] = useState("");
    const [orderPayment, setOrderPayment] = useState("");
    const [orderStatus, setOrderStatus] = useState();
    const [orderDownPayment, setOrderDownPayment] = useState(0);

    useEffect(() => {
        const fetchData = async () => {
            if (!accessToken) return navigate("/");

            axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
            axios.defaults.headers.common['Accept'] = `application/json`;
            await axios.get(`${process.env.REACT_APP_API_URL}/api/user`).then(() => {}).catch(() => navigate("/"));

            axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
            axios.defaults.headers.common['Accept'] = `application/json`;
            await axios.get(`${process.env.REACT_APP_API_URL}/api/order/index?search=${new Date().toISOString().slice(0, 10)}`).then((res) => {
                setOrderData(res.data.data);
            }).catch((err) => {
                if (err.status === 404) setOrderData(err.response.data);
                else setOrderData({"message": "Internal Server Error"});
            })

            axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
            axios.defaults.headers.common['Accept'] = `application/json`;
            await axios.get(`${process.env.REACT_APP_API_URL}/api/order/show?search=${new Date().toISOString().slice(0, 10)}`).then((res) => {
                setOrderDetails(res.data.data);
            }).catch((err) => {
                if (err.status === 404) setOrderDetails(err.response.data);
                else setOrderDetails({"message": "Internal Server Error"});
            })

            await setTimeout(() => setIsPageLoading(false), 500);
            return 1;
        }

        fetchData();
    }, [navigate, accessToken]);

    const handleSearchOrders = async (searchPage = 1) => {
        if (isLoading) return 1;

        setIsLoading(true);
        setOrderPage(searchPage);

        axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
        axios.defaults.headers.common['Accept'] = `application/json`;
        await axios.get(`${process.env.REACT_APP_API_URL}/api/order/index?search=${orderSearch}&page=${searchPage}`).then((res) => {
            setOrderData(res.data.data);
        }).catch((err) => {
            if (err.status === 404) setOrderData(err.response.data);
            else setOrderData({"message": "Internal Server Error"});
        })

        axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
        axios.defaults.headers.common['Accept'] = `application/json`;
        await axios.get(`${process.env.REACT_APP_API_URL}/api/order/show?search=${orderSearch}`).then((res) => {
            setOrderDetails(res.data.data);
        }).catch((err) => {
            if (err.status === 404) setOrderDetails(err.response.data);
            else setOrderDetails({"message": "Internal Server Error"});
        })

        await setIsLoading(false);
        return 1;
    }

    const handleUpdateOrders = async (order) => {
        if (isLoading) return 1;

        const errors = {};

        if (orderDescription && orderDescription?.length > 255) {
            errors.description = "Order description must be less than 255 characters!";
        }

        if (orderPayment && orderPayment !== "cash" && orderPayment !== "transfer" && orderPayment !== "credit") {
            errors.payment = "Order payment must be cash, transfer, or credit!";
        }

        if (orderStatus && orderStatus !== "success" && orderStatus !== "pending" && orderStatus !== "failed") {
            errors.status = "Order status must be success, pending, or failed!";
        }

        if (orderDownPayment && (orderDownPayment < 0 || orderDownPayment > order.total)) {
            errors.down_payment = "Order down payment must be greater than 0 and less than " + order.total + "!";
        }

        if (Object.keys(errors).length > 0) {
            return setAlertMessage(errors);
        }

        setAlertMessage({});
        setIsLoading(true);

        const formData = new FormData();
        formData.append("description", orderDescription);
        if (orderPayment) formData.append("payment", orderPayment);
        if (orderStatus) formData.append("status", orderStatus);
        if (order?.payment === "credit" && orderDownPayment) formData.append("down_payment", orderDownPayment);

        axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
        axios.defaults.headers.common['Accept'] = `application/json`;
        await axios.post(`${process.env.REACT_APP_API_URL}/api/order/update/${order.id}`, formData).then((res) => {
            setIsLoading(false);

            setOrdersShow({ status: false, id: null });
            handleSearchOrders(orderPage);

            return Swal.fire({
                title: "Success!",
                text: res.data.message,
                icon: "success"
            });
        }).catch((err) => {
            setIsLoading(false);

            if (err?.response?.status === 422) {
                return setAlertMessage(err?.response?.data?.errors);
            } else {
                console.error(err);
                setOrdersShow({ status: false, id: null });

                return Swal.fire({
                    title: "Oops!",
                    text: "Internal server error",
                    icon: "error"
                });
            }
        })
        return 1;
    }

    const handleDeleteOrders = async (order_id) => {
        if (isLoading) return 1;

        setOrdersShow({ status: false, id: ordersShow.id });

        Swal.fire({
            title: "Delete Product",
            text: `Are you sure you want to delete ORDER#${order_id}?`,
            icon: "question",
            showCancelButton: true
        }).then(async (r) => {
            if (r.isConfirmed) {
                setIsLoading(true);

                axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
                axios.defaults.headers.common['Accept'] = `application/json`;
                await axios.delete(`${process.env.REACT_APP_API_URL}/api/order/destroy/${order_id}`).then((res) => {
                    setIsLoading(false);
                    handleSearchOrders(orderPage);
                    
                    return Swal.fire({
                        title: "Success!",
                        text: res.data.message,
                        icon: "success"
                    });
                }).catch((err) => {
                    setIsLoading(false);

                    if (err?.response?.status === 404) {
                        return Swal.fire({
                            title: "Oops!",
                            text: err?.response?.data?.message,
                            icon: "error"
                        });
                    } else {
                        console.error(err);

                        return Swal.fire({
                            title: "Oops!",
                            text: "Internal server error",
                            icon: "error"
                        });
                    }
                })
            } else {
                setOrdersShow({ status: true, id: ordersShow.id });
            }
        })
        return 1;
    }

    const handleOrderReceiptShow = (status, id) => {
        if (isLoading) return 1;

        setOrdersShow({ status: !status, id: id });
        setReceiptShow({ status: status, id: id });
        return 1;
    } 

    const handleOrderReceiptPrint = (data) => {
        if (isLoading) return 1;

        localStorage.setItem("orderData", JSON.stringify(data));
        localStorage.setItem("redirectPage", "/orders");

        navigate("/orders/print");
        return 1;
    }

    const calculateTotal = (dataProduct = []) => {
        if (!Array.isArray(dataProduct)) return 0;

        return dataProduct.reduce((total, item) => {
            const quantity = parseInt(item.product_quantity, 10);
            const price = parseInt(item.product_price ?? 0, 10);

            return total + quantity * price;
        }, 0);
    };

    return (
        <section id="orders" className="orders">
            {/* Navigation Bar */}
            <NavigationBar />

            <div className="content-wrapper">
                {/* Side Bar */}
                <SideBar />

                <div className="contents">
                    {!isPageLoading ? (
                        <>
                            <header>
                                <h4>Orders</h4>
                                <div className="d-flex align-items-center justify-content-center gap-2">
                                    <InputGroup>
                                        <Form.Control type="date" disabled={isLoading} placeholder="Search Orders" value={orderSearch} onChange={(e) => setOrderSearch(e.target.value)} />
                                        <Button variant="primary" disabled={isLoading} onClick={handleSearchOrders}><Search /></Button>
                                    </InputGroup>
                                    <Button variant="success" onClick={() => navigate("/orders/store")}><PlusLg /></Button>
                                </div>
                            </header>
                            <main>
                                {orderData?.message && <h6>{orderData.message}</h6>}

                                {orderData?.data?.map((item, index) => (
                                    <div key={index} className="order-card" onClick={() => setOrdersShow({ status: true, id: index })}>
                                        <div className="order-card-image">
                                            <h6>#{item.id}</h6>
                                        </div>
                                        <div className="order-card-body">
                                            <div>
                                                <p>{item.payment === "credit" ? `${formatRupiah(item.down_payment)} / ${formatRupiah(item.total)}` : formatRupiah(item.total)} ({item.payment})</p>
                                                <Badge bg={item.status === "pending" ? "warning" : item.status === "failed" ? "danger" : "success"}>{item.status}</Badge>
                                            </div>
                                            <div>
                                                <p>{item.description ? item.description.slice(0, 16) + "..." : "-"}</p>
                                                <p>{formatDateTime(item.created_at)}</p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
        
                                {orderDetails?.status && (
                                    <div className="order-card">
                                        <div className="order-card-body">
                                            <div className="d-flex flex-column align-items-center justify-content-center">
                                                <h5>{orderDetails?.status?.total_success}</h5>
                                                <Badge bg="success">success</Badge>
                                            </div>
                                            <p>+</p>
                                            <div className="d-flex flex-column align-items-center justify-content-center">
                                                <h5>{orderDetails?.status?.total_pending}</h5>
                                                <Badge bg="warning">pending</Badge>
                                            </div>
                                            <p>+</p>
                                            <div className="d-flex flex-column align-items-center justify-content-center">
                                                <h5>{orderDetails?.status?.total_failed}</h5>
                                                <Badge bg="danger">failed</Badge>
                                            </div>
                                            <p>=</p>
                                            <div className="d-flex flex-column align-items-center justify-content-center">
                                                <h5>{orderDetails?.status?.total_overall}</h5>
                                                <Badge bg="primary">overall</Badge>
                                            </div>
                                        </div>
                                    </div>
                                )}
        
                                {orderDetails?.payment && (
                                    <div className="order-card">
                                        <div className="order-card-body">
                                            <div className="d-flex flex-column align-items-center justify-content-center">
                                                <h5>{formatRupiah(orderDetails?.payment?.total_cash)}</h5>
                                                <Badge bg="success">cash</Badge>
                                            </div>
                                            <p>+</p>
                                            <div className="d-flex flex-column align-items-center justify-content-center">
                                                <h5>{formatRupiah(orderDetails?.payment?.total_transfer)}</h5>
                                                <Badge bg="warning">transfer</Badge>
                                            </div>
                                            <p>+</p>
                                            <div className="d-flex flex-column align-items-center justify-content-center">
                                                <h5>{formatRupiah(orderDetails?.payment?.balance_credit)} / {formatRupiah(orderDetails?.payment?.total_credit)}</h5>
                                                <Badge bg="danger">credit</Badge>
                                            </div>
                                            <p>=</p>
                                            <div className="d-flex flex-column align-items-center justify-content-center">
                                                <h5>{formatRupiah(orderDetails?.payment?.total_overall)}</h5>
                                                <Badge bg="primary">overall</Badge>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </main>
                            {orderData?.last_page > 1 && (
                                <footer>
                                    <PaginationAdvanced arrayData={orderData} handleSearchData={handleSearchOrders} />
                                </footer>
                            )}
                        </>
                    ) : (
                        <>
                            <header>
                                <Placeholder animation="glow">
                                    <Placeholder style={{ borderRadius: "8px",  width: "100px", height: "24px" }} />
                                </Placeholder>
                                <div className="d-flex align-items-center justify-content-center gap-2">
                                    <Placeholder animation="glow">
                                        <Placeholder style={{ borderRadius: "8px",  width: "250px", height: "32px" }} />
                                    </Placeholder>
                                    <Placeholder animation="glow">
                                        <Placeholder style={{ borderRadius: "8px",  width: "32px", height: "32px" }} />
                                    </Placeholder>
                                </div>
                            </header>
                            <main>
                                {Array.from({ length: 10 }).map((_, index) => (
                                    <div key={index} className="order-card">
                                        <Placeholder className="order-card-image" animation="glow">
                                            <Placeholder style={{ borderRadius: "8px",  width: "100%", height: "100%" }} />
                                        </Placeholder>
                                        <div className="order-card-body">
                                            <div className="d-flex flex-column">
                                                <Placeholder animation="glow">
                                                    <Placeholder style={{ borderRadius: "8px",  width: "150px", height: "16px" }} />
                                                </Placeholder>
                                                <Placeholder animation="glow">
                                                    <Placeholder style={{ borderRadius: "8px",  width: "75px", height: "16px" }} />
                                                </Placeholder>
                                            </div>
                                            <div className="d-flex flex-column align-items-end">
                                                <Placeholder animation="glow">
                                                    <Placeholder style={{ borderRadius: "8px",  width: "150px", height: "16px" }} />
                                                </Placeholder>
                                                <Placeholder animation="glow">
                                                    <Placeholder style={{ borderRadius: "8px",  width: "175px", height: "16px" }} />
                                                </Placeholder>
                                            </div>
                                        </div>
                                    </div>
                                ))}

                                <div className="order-card">
                                    <div className="order-card-body">
                                        <div className="d-flex flex-column align-items-center justify-content-center">
                                            <Placeholder animation="glow">
                                                <Placeholder style={{ borderRadius: "8px",  width: "125px", height: "24px", marginBottom: "8px" }} />
                                            </Placeholder>
                                            <Placeholder animation="glow">
                                                <Placeholder style={{ borderRadius: "4px",  width: "75px", height: "16px" }} />
                                            </Placeholder>
                                        </div>
                                        <p>+</p>
                                        <div className="d-flex flex-column align-items-center justify-content-center">
                                            <Placeholder animation="glow">
                                                <Placeholder style={{ borderRadius: "8px",  width: "125px", height: "24px", marginBottom: "8px" }} />
                                            </Placeholder>
                                            <Placeholder animation="glow">
                                                <Placeholder style={{ borderRadius: "4px",  width: "75px", height: "16px" }} />
                                            </Placeholder>
                                        </div>
                                        <p>+</p>
                                        <div className="d-flex flex-column align-items-center justify-content-center">
                                            <Placeholder animation="glow">
                                                <Placeholder style={{ borderRadius: "8px",  width: "125px", height: "24px", marginBottom: "8px" }} />
                                            </Placeholder>
                                            <Placeholder animation="glow">
                                                <Placeholder style={{ borderRadius: "4px",  width: "75px", height: "16px" }} />
                                            </Placeholder>
                                        </div>
                                        <p>=</p>
                                        <div className="d-flex flex-column align-items-center justify-content-center">
                                            <Placeholder animation="glow">
                                                <Placeholder style={{ borderRadius: "8px",  width: "125px", height: "24px", marginBottom: "8px" }} />
                                            </Placeholder>
                                            <Placeholder animation="glow">
                                                <Placeholder style={{ borderRadius: "4px",  width: "75px", height: "16px" }} />
                                            </Placeholder>
                                        </div>
                                    </div>
                                </div>

                                <div className="order-card">
                                    <div className="order-card-body">
                                        <div className="d-flex flex-column align-items-center justify-content-center">
                                            <Placeholder animation="glow">
                                                <Placeholder style={{ borderRadius: "8px",  width: "125px", height: "24px", marginBottom: "8px" }} />
                                            </Placeholder>
                                            <Placeholder animation="glow">
                                                <Placeholder style={{ borderRadius: "4px",  width: "75px", height: "16px" }} />
                                            </Placeholder>
                                        </div>
                                        <p>+</p>
                                        <div className="d-flex flex-column align-items-center justify-content-center">
                                            <Placeholder animation="glow">
                                                <Placeholder style={{ borderRadius: "8px",  width: "125px", height: "24px", marginBottom: "8px" }} />
                                            </Placeholder>
                                            <Placeholder animation="glow">
                                                <Placeholder style={{ borderRadius: "4px",  width: "75px", height: "16px" }} />
                                            </Placeholder>
                                        </div>
                                        <p>+</p>
                                        <div className="d-flex flex-column align-items-center justify-content-center">
                                            <Placeholder animation="glow">
                                                <Placeholder style={{ borderRadius: "8px",  width: "125px", height: "24px", marginBottom: "8px" }} />
                                            </Placeholder>
                                            <Placeholder animation="glow">
                                                <Placeholder style={{ borderRadius: "4px",  width: "75px", height: "16px" }} />
                                            </Placeholder>
                                        </div>
                                        <p>=</p>
                                        <div className="d-flex flex-column align-items-center justify-content-center">
                                            <Placeholder animation="glow">
                                                <Placeholder style={{ borderRadius: "8px",  width: "125px", height: "24px", marginBottom: "8px" }} />
                                            </Placeholder>
                                            <Placeholder animation="glow">
                                                <Placeholder style={{ borderRadius: "4px",  width: "75px", height: "16px" }} />
                                            </Placeholder>
                                        </div>
                                    </div>
                                </div>
                            </main>
                            <footer>
                                <Placeholder animation="glow">
                                    <Placeholder style={{ borderRadius: "4px",  width: "150px", height: "38px" }} />
                                </Placeholder>
                            </footer>
                        </>
                    )}
                </div>
            </div>

            {/* Orders Modal */}
            <Modal id="orders-modal" show={ordersShow.status} onHide={() => setOrdersShow({ status: false, id: null })} centered scrollable>
                <Modal.Header closeButton>
                    <Modal.Title>ORDER#{orderData?.data?.[ordersShow.id]?.id}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">Order Description</Form.Label>
                        <Form.Control type="text" placeholder="Enter Order Description" defaultValue={orderData?.data?.[ordersShow.id]?.description} onChange={(e) => setOrderDescription(e.target.value)} disabled={isLoading} />
                        {alertMessage?.description && <Form.Text className="text-danger">{alertMessage.description}</Form.Text>}
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">Order Payment</Form.Label>
                        <Form.Select defaultValue={orderData?.data?.[ordersShow.id]?.payment} onChange={(e) => setOrderPayment(e.target.value)} disabled={isLoading}>
                            <option value="cash">Cash</option>
                            <option value="transfer">Transfer</option>
                            <option value="credit">Credit</option>
                        </Form.Select>
                        {alertMessage?.payment && <Form.Text className="text-danger">{alertMessage.payment}</Form.Text>}
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">Order Status</Form.Label>
                        <Form.Select defaultValue={orderData?.data?.[ordersShow.id]?.status} onChange={(e) => setOrderStatus(e.target.value)} disabled={isLoading}>
                            <option value="success">Success</option>
                            <option value="pending">Pending</option>
                            <option value="failed">Failed</option>
                        </Form.Select>
                        {alertMessage?.status && <Form.Text className="text-danger">{alertMessage.status}</Form.Text>}
                    </Form.Group>
                    {orderData?.data?.[ordersShow.id]?.payment === "credit" && (
                        <Form.Group className="mb-3">
                            <Form.Label className="fw-semibold">Order Down Payment</Form.Label>
                            <Form.Control type="text" placeholder="Enter Order Down Payment" defaultValue={orderData?.data?.[ordersShow.id]?.down_payment} onChange={(e) => setOrderDownPayment(e.target.value)} disabled={isLoading} />
                            {alertMessage?.down_payment && <Form.Text className="text-danger">{alertMessage.down_payment}</Form.Text>}
                        </Form.Group>
                    )}

                    <p className="mb-2 fw-semibold">Order Product</p>
                    <div className="d-flex flex-column align-items-center justify-content-center gap-2">
                        {orderData?.data?.[ordersShow.id]?.order_products?.map((item, index) => (
                            <div key={index} className="product-card">
                                <div className="product-card-image">
                                    <img src={process.env.REACT_APP_API_URL + '/storage/products/' + item.product_image} alt="" />
                                </div>
                                <div className="product-card-body">
                                    <div>
                                        <h6>{item.product_name}</h6>
                                        <p>{item.product_quantity} x {formatRupiah(item.product_price)} = {formatRupiah(item.product_quantity * item.product_price)}</p>
                                    </div>
                                    {/* <div>
                                        <InputGroup size="sm">
                                            <Button variant="outline-secondary" onClick={() => decreaseQuantity(item.product_id)}><Dash /></Button>
                                            <Form.Control type="number" min={0} max={selectedProduct?.stock} value={item.quantity} onChange={(e) => handleQuantityChange(item.product_id, e.target.value)} className="text-center" />
                                            <Button variant="outline-secondary" disabled={item.quantity >= selectedProduct?.stock} onClick={() => increaseQuantity(item.product_id)}><Plus /></Button>
                                        </InputGroup>
                                    </div> */}
                                </div>
                            </div>
                        ))}
                    </div>

                    <p className="mt-3 mb-2 fw-semibold">Order Menu</p>
                    <Button variant="primary" className="w-100" onClick={() => handleOrderReceiptShow(true, ordersShow.id)} disabled={isLoading}>Print</Button>
                    <Button variant="danger" className="w-100 mt-2" onClick={() => handleDeleteOrders(orderData?.data?.[ordersShow.id]?.id)} disabled={isLoading}>Delete</Button>
                </Modal.Body>
                <Modal.Footer>
                    <h5 className="modal-footer-total">{orderData?.data?.[ordersShow.id]?.payment === "credit" ? `${formatRupiah(orderData?.data?.[ordersShow.id]?.down_payment)} / ${formatRupiah(orderData?.data?.[ordersShow.id]?.total)}` : formatRupiah(orderData?.data?.[ordersShow.id]?.total)}</h5>
                    <Button variant="primary" disabled={isLoading} onClick={() => handleUpdateOrders(orderData?.data?.[ordersShow.id])}>
                        {isLoading && <Spinner size="sm" className="me-2" />}
                        Save Changes
                    </Button>
                    <Button variant="secondary" onClick={() => setOrdersShow({ status: false, id: null })}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
            {/* End of Orders Modal */}

            {/* Receipt Modal */}
            <Modal id="receipt-modal" show={receiptShow.status} onHide={() => setReceiptShow({ status: false, id: null })} centered scrollable>
                <Modal.Header closeButton>
                    <Modal.Title>Receipt</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="modal-body-header">
                        <img src={imageLogo} alt="Aulia Printing" />
                    </div>
                    <hr className="divider" />
                    <div className="d-flex align-items-center justify-content-between">
                        <p>{formatDateTime(orderData?.data?.[receiptShow.id]?.created_at)}</p>
                        <p>ORDER#{orderData?.data?.[receiptShow.id]?.id}</p>
                    </div>
                    <hr className="divider" />
                    <div className="d-flex flex-column gap-2">
                        {orderData?.data?.[receiptShow.id]?.order_products?.map((item, index) => (
                            <div key={index}>
                                <h6>{item.product_name}</h6>
                                <div className="d-flex align-items-center justify-content-between">
                                    <p>{item.product_quantity} x {formatRupiah(item.product_price)}</p>
                                    <p>{formatRupiah(item.product_quantity * item.product_price)}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                    <hr className="divider" />
                    <div className="d-flex align-items-center justify-content-between">
                        <p>Total</p>
                        <p>{formatRupiah(calculateTotal(orderData?.data?.[receiptShow.id]?.order_products))}</p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between">
                        <p>Paid ({orderData?.data?.[receiptShow.id]?.payment})</p>
                        <p>{formatRupiah(orderData?.data?.[receiptShow.id]?.down_payment)}</p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between">
                        <p>Change</p>
                        <p>{formatRupiah(orderData?.data?.[receiptShow.id]?.down_payment - calculateTotal(orderData?.data?.[receiptShow.id]?.order_products))}</p>
                    </div>

                    <hr className="divider" />

                    {orderData?.description && <p className="mt-2 text-center">{orderData?.description}</p>}

                    <p className="mt-3 text-center">Thank you for your purchase! We look forward to serving you again.</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={() => handleOrderReceiptPrint(orderData?.data?.[receiptShow.id])}>Print</Button>
                    <Button variant="secondary" onClick={() => handleOrderReceiptShow(false, receiptShow.id)}>Close</Button>
                </Modal.Footer>
            </Modal>
            {/* End of Receipt Modal */}
        </section>
    )
}

export default PageOrders